import React from 'react';

import Typography from '@material-ui/core/Typography';
import { Theme } from '@material-ui/core/styles';
import styled from '@material-ui/core/styles/styled';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';
import { LazyLoadImage } from '../../../LazyloadImage';
import useStyles from './styles';

interface SlideProps {
  imagePath: string;
  listItems: string[];
  title: string;
}

const Slide = ({ imagePath, listItems = [], title }: SlideProps) => {
  const classes = useStyles();
  return (
    <Wrapper className="swiper-slide" data-testid="tabsSliderBlockSlide">
      <Shadow>
        <LazyLoadImage
          data-testId="slide-img"
          imageWrapperClass={classes.wrapper}
          path={imagePath}
        />
        <SlideContent>
          <Title data-testId="slide-title">{title}</Title>
          <List>
            {listItems.map((item, index) => (
              <ListItem key={index} data-testId="slide-list-item">
                {item}
              </ListItem>
            ))}
          </List>
        </SlideContent>
      </Shadow>
    </Wrapper>
  );
};

export default Slide;

const Title = styled(Typography)(({ theme }: { theme: Theme }) => ({
  marginBottom: 24,
  fontWeight: 700,
  fontSize: 18,
  [theme.breakpoints.up('md')]: {
    fontSize: 20,
  },
}));
const Wrapper = styled('div')({
  maxWidth: '100%',
  height: 'auto',
});
const Shadow = styled('div')(({ theme }: { theme: Theme }) => ({
  height: '100%',
  margin: '3px 3px 5px',
  overflow: 'hidden',
  borderRadius: 8,
  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.4)',
  background: colorsPalette.blueDark,
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    height: 500,
  },
}));
const SlideContent = styled('div')(({ theme }: { theme: Theme }) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  padding: `16px 16px ${MIDDLE_MARGIN}px`,
  [theme.breakpoints.up('sm')]: {
    padding: `24px 24px ${MIDDLE_MARGIN}px`,
  },
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    padding: `${LARGE_MARGIN}px 0 0 ${LARGE_MARGIN}px`,
  },
}));
const List = styled('ul')({
  padding: 0,
  listStyleType: 'none',
});
const ListItem = styled('li')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: SMALL_MARGIN,
  color: colorsPalette.gray,
  fontSize: 16,
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    marginRight: MIDDLE_MARGIN,
    fontSize: 20,
  },
  '&:before': {
    content: '""',
    display: 'block',
    height: 8,
    width: 8,
    minWidth: 8,
    marginTop: 8,
    marginRight: 8,
    borderRadius: '50%',
    background: colorsPalette.blue,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      marginRight: SMALL_MARGIN,
    },
  },
}));
